export default "__VITE_ASSET__2N5tiRm$__"